import type { ReactNode } from 'react'

/**
 * Wat je krijgt als het invite token ontbreekt of niet meer klopt.
 *
 * De tekst zegt met opzet niets over of dit feest bestaat. De API geeft op een
 * fout token exact dezelfde 404 als op een onbekende slug — zou dat verschillen,
 * dan is dat verschil een orakel waarmee je kan aflopen welke feesten er zijn.
 * De UI mag dat onderscheid dus ook niet per ongeluk teruggeven.
 */
export function BrokenLink({
  title = 'Deze link werkt niet',
  detail = 'Scan de QR-code op tafel nog een keer, of vraag het bruidspaar om een nieuwe link.',
}: {
  title?: string

  /**
   * Mag opmaak bevatten. De gastenkant houdt het bij tekst, maar het scherm dat
   * je krijgt op een adres dat nergens heen gaat wijst je door naar het beheer,
   * en een pad dat je zelf moet overtypen is geen doorverwijzing.
   */
  detail?: ReactNode
}) {
  return (
    <main className="flex min-h-full flex-col items-center justify-center px-8 text-center">
      <div className="max-w-md">
        <h1 className="font-display text-[38px] leading-tight sm:text-[52px]">{title}</h1>
        <p className="text-ink-muted mt-4 text-base leading-relaxed text-pretty sm:text-lg">
          {detail}
        </p>
      </div>
    </main>
  )
}
